import { createConfig, http } from 'wagmi';
import { mainnet } from 'wagmi/chains';
import { walletConnect, injected } from 'wagmi/connectors';
import { getEnv } from '~/env';
import { defineChain } from 'viem';

// Define Japan Open Chain
const jocChainId = parseInt(getEnv('NEXT_PUBLIC_JOC_CHAIN_ID') || '81', 10);
const jocRpcUrl = getEnv('NEXT_PUBLIC_JOC_URL') || 'https://rpc-1.japanopenchain.org:8545';
const jocExplorerUrl = getEnv('NEXT_PUBLIC_EXPLORER_URL') || 'https://explorer.japanopenchain.org';

export const japanOpenChain = defineChain({
  id: jocChainId,
  name: 'Japan Open Chain',
  nativeCurrency: {
    name: 'Japan Open Chain Token',
    symbol: 'JOC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [jocRpcUrl],
    },
  },
  blockExplorers: {
    default: {
      name: 'JOC Explorer',
      url: jocExplorerUrl,
    },
  },
});

// Define Japan Open Chain Testnet
const jocTestnetChainId = parseInt(getEnv('NEXT_PUBLIC_JOC_TESTNET_CHAIN_ID') || '10081', 10);
const jocTestnetRpcUrl =
  getEnv('NEXT_PUBLIC_JOC_TESTNET_URL') || 'https://rpc-1.testnet.japanopenchain.org:8545';

export const japanOpenChainTestnet = defineChain({
  id: jocTestnetChainId,
  name: 'Japan Open Chain Testnet',
  nativeCurrency: {
    name: 'Japan Open Chain Token',
    symbol: 'JOC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [jocTestnetRpcUrl],
    },
  },
  blockExplorers: {
    default: {
      name: 'JOC Explorer',
      url: 'https://explorer.testnet.japanopenchain.org',
    },
  },
  testnet: true,
});

// WalletConnect project ID
const walletConnectProjectId = getEnv('NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID');
const isValidProjectId =
  walletConnectProjectId &&
  walletConnectProjectId !== '' &&
  !walletConnectProjectId.startsWith('dummy') &&
  walletConnectProjectId.length >= 32;
const isBrowser = typeof window !== 'undefined';

// Create wagmi config
export const wagmiConfig = createConfig({
  chains: [japanOpenChain, japanOpenChainTestnet, mainnet],
  transports: {
    [japanOpenChain.id]: http(jocRpcUrl),
    [japanOpenChainTestnet.id]: http(jocTestnetRpcUrl),
    [mainnet.id]: http(),
  },
  connectors: [
    injected(),
    ...(isBrowser && isValidProjectId
      ? [
          walletConnect({
            projectId: walletConnectProjectId!,
            showQrModal: false,
          }),
        ]
      : []),
  ],
});

export function getWagmiConfig() {
  return wagmiConfig;
}
